import React from "react";
import {
  FaCheckCircle,
  FaMobileAlt,
  FaUserGraduate,
  FaRocket,
  FaBrain,
  FaHandshake,
} from "react-icons/fa";
import aboutus from '../../assets/images/aboutus.png'

const About = () => {
  return (
    <div className="bg-white text-black font-sans px-6 py-16">
      {/* Header */}
      <div className="max-w-6xl mx-auto text-center mb-16">
        <h1 className="text-4xl sm:text-5xl font-bold text-[#fc3c04] mb-4">
          About <span className="text-[#345bf3]">FOICT</span> 
        </h1>
        <h2 className="text-xl font-semibold text-[#686104] mb-4">
          Finding Opportunities In Changing Times
        </h2>
        <p className="text-lg text-gray-700">
          FOICT is committed to helping individuals and organizations thrive in a fast-changing world through a forward-thinking approach to education.
        </p>
      </div>

      {/* Skills Section */}
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center mt-12">
        {/* List Content */}
        <div>
          <h2 className="text-3xl font-bold text-[#fc3c04] mb-4">Our Key Areas</h2>
          <ul className="list-disc pl-6 space-y-4 text-gray-700 text-base leading-relaxed">
            <li>
              <strong className="text-[#345bf3]">Skill-Based Learning:</strong> Value-driven programs from soft skills to enterprise sales leadership tailored for today's market.
            </li>
            <li>
              <strong className="text-[#345bf3]">Digital Innovation:</strong> Learning with mobile apps, online platforms, and AI for continuous personal and professional growth.
            </li>
            <li>
              <strong className="text-[#345bf3]">Career Transformation:</strong> From learners to leaders—equipping individuals with tools and a global success mindset.
            </li>
            <li>
              <strong className="text-[#345bf3]">Embracing Change for Growth:</strong> Unlock new opportunities with future-ready skills and innovation.
            </li>
            <li>
              <strong className="text-[#345bf3]">Your Partner in Progress:</strong> Empowering career advancement, leadership, and digital adaptability.
            </li>
          </ul>
        </div>

        {/* Image */}
     <div className="w-full">
  <img
    src={aboutus}
    alt="Learning and Growth"
    className="rounded-lg object-contain w-full max-h-[500px]"
  />
</div>

      </div>

      {/* Why Choose FOICT */}
      <div className="max-w-7xl mx-auto mt-20">
        <h2 className="text-3xl font-bold text-center text-[#fc3c04] mb-10">
          Why Choose <span className="text-[#345bf3]">FOICT</span>
        </h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            {
              title: "Verified Listings",
              desc: "Only genuine and vetted job opportunities are published.",
              icon: <FaCheckCircle className="text-[#345bf3] text-3xl" />,
            },
            {
              title: "User-Friendly",
              desc: "Clean, mobile-first UI for seamless job searches anytime.",
              icon: <FaMobileAlt className="text-[#345bf3] text-3xl" />,
            },
            {
              title: "Career Support",
              desc: "Get expert advice with resume tips and interview prep.",
              icon: <FaUserGraduate className="text-[#345bf3] text-3xl" />,
            },
          ].map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 p-6 bg-white border border-gray-200 rounded-lg shadow hover:shadow-md transition"
            >
              <div>{item.icon}</div>
              <div>
                <h3 className="font-bold text-lg text-[#fc3c04] mb-1">{item.title}</h3>
                <p className="text-gray-600 text-sm">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Team Section */}
      <div className="max-w-7xl mx-auto mt-20">
        <h2 className="text-3xl font-bold text-center text-[#fc3c04] mb-10">
          Meet Our <span className="text-[#345bf3]">Team</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8 text-center">
          {[
            {
              name: "Amit Sharma",
              role: "Founder & CEO",
              img: "https://randomuser.me/api/portraits/men/9.jpg",
            },
            {
              name: "Shivani Verma",
              role: "Operations Head",
              img: "https://randomuser.me/api/portraits/women/32.jpg",
            },
            {
              name: "Rahul Mehta",
              role: "Lead Developer",
              img: "https://randomuser.me/api/portraits/men/39.jpg",
            },
          ].map((member, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-4 hover:shadow-md transition"
            >
              <img
                src={member.img}
                alt={member.name}
                className="w-24 h-24 mx-auto rounded-full mb-4 object-cover"
              />
              <h3 className="text-lg font-semibold text-[#fc3c04]">{member.name}</h3>
              <p className="text-sm">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default About;
